var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-kravicka", {
        attrs: { profil: _vm.profil },
        on: { updateProfil: _vm.emitUpdateProfil }
      }),
      _vm._v(" "),
      _c("main", [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row justify-content-center" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-xs-12 col-sm-12 col-md-12 col-lg-4 mb-5 mb-lg-0"
              },
              [
                _c("h2", [_vm._v("Tabuľka najlepších hráčov")]),
                _vm._v(" "),
                _c("span", { staticClass: "customLabel" }, [_vm._v("Pexeso")]),
                _vm._v(" "),
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "router-link",
                  {
                    staticClass: "btn --primary --large --startGame",
                    attrs: {
                      to: {
                        name: "pexeso-settings",
                        params: { kravicka_id: _vm.$route.params.kravicka_id }
                      }
                    }
                  },
                  [
                    _c("span", { staticClass: "icon" }),
                    _vm._v("Spustiť hru\n                    ")
                  ]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-12 col-lg-8" },
              [
                _c("nav", [
                  _c(
                    "div",
                    {
                      staticClass: "nav nav-tabs",
                      attrs: { id: "nav-tab", role: "tablist" }
                    },
                    [
                      _vm._l(_vm.pexesoObtiaznosti, function(
                        pexesoObtiaznost,
                        index
                      ) {
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "nav-item nav-link",
                              class: {
                                active:
                                  pexesoObtiaznost.id === _vm.selectedObtiaznost
                              },
                              on: {
                                click: function($event) {
                                  return _vm.changeObtiaznost(
                                    pexesoObtiaznost.id
                                  )
                                }
                              }
                            },
                            [
                              _c("span", [_vm._v(_vm._s(index + 1) + ".")]),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    pexesoObtiaznost.pexeso_obtiaznost_nadpis
                                  ) +
                                  "\n                                "
                              )
                            ]
                          )
                        ]
                      })
                    ],
                    2
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "tab-content",
                    attrs: { id: "nav-tabContent" }
                  },
                  [
                    _c("div", { staticClass: "tab-pane fade show active" }, [
                      _c("table", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.leaders, function(leader, index) {
                            return _c("tr", [
                              _c("td", [_vm._v(_vm._s(index + 1))]),
                              _vm._v(" "),
                              _c("td", { staticClass: "name" }, [
                                _vm._v(
                                  _vm._s(leader.pouzivatel_id.pouzivatel_name)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s(leader.pexeso_leaderboard_pocet_tahov)
                                )
                              ]),
                              _vm._v(" "),
                              _c("td", { staticClass: "text-right time" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getTime(leader.pexeso_leaderboard_cas)
                                  )
                                )
                              ])
                            ])
                          }),
                          0
                        )
                      ])
                    ])
                  ]
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "pexesoFooter --right" },
        [
          _c(
            "router-link",
            {
              staticClass: "btn --primary closeGame",
              attrs: {
                to: {
                  name: "kravicka",
                  params: { kravicka_id: _vm.$route.params.kravicka_id }
                }
              }
            },
            [_c("span", { staticClass: "icon" })]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "mb-4 scoreDescription" }, [
      _vm._v("Každý súťaživý hráč sa raz nájde v tabuľke najlepších hráčov."),
      _c("br"),
      _vm._v("Veľa šťastia, kamaráti!")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("#")]),
        _vm._v(" "),
        _c("th", [_vm._v("Hráč")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Počet ťahov")]),
        _vm._v(" "),
        _c("th", { staticClass: "text-right" }, [_vm._v("Čas")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }